import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card shadow mx-0 mb-4 create-order-component animated fadeIn"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-header py-3 d-flex flex-row align-items-center justify-content-start" }, [
  /*#__PURE__*/_createVNode("h6", { class: "m-0 font-weight-bold" }, [
    /*#__PURE__*/_createTextVNode(" Edit Manual Order "),
    /*#__PURE__*/_createVNode("small", { class: "ml-2" }, "Please provide the required information.")
  ])
], -1)
const _hoisted_3 = { class: "card-body text-center" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h4", {
  class: "mb-3",
  style: {"background-color":"#f8f9fa","padding":"12px","margin-bottom":"0","border-bottom":"1px solid #e9ecef"}
}, " Client Order ", -1)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6 text-left" }
const _hoisted_8 = { class: "row mt-2" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Pair ", -1)
const _hoisted_10 = { class: "col-6 text-right" }
const _hoisted_11 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Side ", -1)
const _hoisted_14 = { class: "col-6 text-right" }
const _hoisted_15 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_16 = {
  key: 1,
  class: "badge badge-danger"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Amount ", -1)
const _hoisted_20 = { class: "col-6 text-right" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_22 = { style: {"font-size":"18px"} }
const _hoisted_23 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_24 = { class: "row" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "col-6 text-left font-weight-bold" }, " Unit Price ", -1)
const _hoisted_26 = { class: "col-6 text-right" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_28 = { style: {"font-size":"18px"} }
const _hoisted_29 = { class: "col-md-6 text-left px-3" }
const _hoisted_30 = {
  class: "card",
  style: {"font-size":"0.9rem"}
}
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, " Order Summary ", -1)
const _hoisted_32 = { class: "card-body py-0" }
const _hoisted_33 = {
  class: "table text-left mb-0 details-table",
  style: {"margin-top":"10px"}
}
const _hoisted_34 = { class: "table-list-header" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Order Amount ")
const _hoisted_36 = {
  key: 0,
  class: "badge badge-pill badge-info target-badge little-pill"
}
const _hoisted_37 = { class: "table-list-value" }
const _hoisted_38 = { class: "table-list-header" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Order Total Price ")
const _hoisted_40 = {
  key: 0,
  class: "badge badge-pill badge-info target-badge little-pill"
}
const _hoisted_41 = { class: "table-list-value" }
const _hoisted_42 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, " CAD Reference Value ", -1)
const _hoisted_43 = { class: "table-list-value" }
const _hoisted_44 = /*#__PURE__*/_createVNode("td", {
  class: "table-list-header",
  style: {"border-top-width":"1px"}
}, " Filling Orders Total Amount ", -1)
const _hoisted_45 = {
  class: "table-list-value",
  style: {"border-top-width":"1px"}
}
const _hoisted_46 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, " Filling Orders Total Price ", -1)
const _hoisted_47 = { class: "table-list-value" }
const _hoisted_48 = { class: "table-list-header" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Order Completion ")
const _hoisted_50 = {
  key: 0,
  class: "badge badge-pill badge-warning little-pill"
}
const _hoisted_51 = {
  key: 1,
  class: "badge badge-pill badge-warning little-pill"
}
const _hoisted_52 = {
  key: 2,
  class: "badge badge-pill badge-success little-pill"
}
const _hoisted_53 = { class: "table-list-value text-right" }
const _hoisted_54 = { colspan: "2" }
const _hoisted_55 = /*#__PURE__*/_createVNode("div", {
  class: "card-header",
  style: {"border-top":"1px solid #e3e6f0"}
}, " Revenues ", -1)
const _hoisted_56 = { class: "card-body py-0" }
const _hoisted_57 = {
  class: "table text-left mb-0 details-table",
  style: {"margin-top":"10px"}
}
const _hoisted_58 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Base Currency"),
  /*#__PURE__*/_createVNode("td", { class: "table-list-header text-right" }, " Quote Currency ")
], -1)
const _hoisted_59 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_60 = {
  key: 0,
  style: {"font-weight":"600"}
}
const _hoisted_61 = {
  key: 1,
  style: {"font-weight":"600"}
}
const _hoisted_62 = {
  key: 2,
  style: {"font-weight":"600"}
}
const _hoisted_63 = { class: "text-right" }
const _hoisted_64 = {
  key: 0,
  style: {"font-weight":"600"}
}
const _hoisted_65 = {
  key: 1,
  style: {"font-weight":"600"}
}
const _hoisted_66 = {
  key: 2,
  style: {"font-weight":"600"}
}
const _hoisted_67 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { class: "table-list-value text-left" }
const _hoisted_70 = { class: "table-list-value" }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "col-12 mt-5" }
const _hoisted_74 = /*#__PURE__*/_createVNode("h4", {
  class: "mb-3",
  style: {"background-color":"#f8f9fa","padding":"12px","margin-bottom":"0","border-bottom":"1px solid #e9ecef"}
}, " Filling Orders ", -1)
const _hoisted_75 = { class: "row text-left" }
const _hoisted_76 = { class: "col-md-4" }
const _hoisted_77 = { class: "form-group" }
const _hoisted_78 = /*#__PURE__*/_createVNode("label", { for: "provider-field" }, "Provider", -1)
const _hoisted_79 = /*#__PURE__*/_createVNode("option", {
  disabled: "",
  value: "",
  selected: "selected"
}, "Please select", -1)
const _hoisted_80 = { class: "col-md-8" }
const _hoisted_81 = { class: "form-group" }
const _hoisted_82 = /*#__PURE__*/_createVNode("label", { for: "provider-order-id" }, " Provider Order Id (optional) ", -1)
const _hoisted_83 = { class: "col-md-4" }
const _hoisted_84 = /*#__PURE__*/_createVNode("label", { for: "amount-field" }, " Amount ", -1)
const _hoisted_85 = { class: "input-group mb-3" }
const _hoisted_86 = { class: "input-group-prepend" }
const _hoisted_87 = { class: "input-group-text p-0 bg-primary" }
const _hoisted_88 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-arrow-alt-circle-up",
  title: "Maximum"
}, null, -1)
const _hoisted_89 = { class: "input-group-text" }
const _hoisted_90 = { class: "col-md-4" }
const _hoisted_91 = { class: "form-group" }
const _hoisted_92 = /*#__PURE__*/_createVNode("label", { for: "cost-field" }, " Unit Price ", -1)
const _hoisted_93 = { class: "input-group" }
const _hoisted_94 = { class: "input-group-prepend" }
const _hoisted_95 = { class: "input-group-text" }
const _hoisted_96 = { class: "col-md-4" }
const _hoisted_97 = { class: "form-group" }
const _hoisted_98 = /*#__PURE__*/_createVNode("label", { for: "cost-field" }, " Total Cost ", -1)
const _hoisted_99 = { class: "input-group" }
const _hoisted_100 = { class: "input-group-prepend" }
const _hoisted_101 = { class: "input-group-text" }
const _hoisted_102 = { class: "row text-left mb-3" }
const _hoisted_103 = { class: "col-md-4" }
const _hoisted_104 = /*#__PURE__*/_createVNode("label", { for: "datetime-field" }, "Settlement Date Time", -1)
const _hoisted_105 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_106 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_107 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_108 = { class: "col-md-1" }
const _hoisted_109 = /*#__PURE__*/_createVNode("label", { for: "datetime-field" }, " ", -1)
const _hoisted_110 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_111 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_112 = /*#__PURE__*/_createTextVNode(" No filling orders. ")
const _hoisted_113 = /*#__PURE__*/_createVNode("i", { class: "fas fa-info-circle" }, null, -1)
const _hoisted_114 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_115 = { class: "card-footer" }
const _hoisted_116 = { class: "container" }
const _hoisted_117 = { class: "row" }
const _hoisted_118 = { class: "col-md-12 text-right" }
const _hoisted_119 = { class: "container" }
const _hoisted_120 = /*#__PURE__*/_createVNode("div", { class: "row" }, [
  /*#__PURE__*/_createVNode("div", { class: "col-12" }, " Are you sure you want to close this order? ")
], -1)
const _hoisted_121 = { class: "row" }
const _hoisted_122 = { class: "col-12" }
const _hoisted_123 = { class: "row" }
const _hoisted_124 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_icons_currency = _resolveComponent("icons-currency")
  const _component_amountInput = _resolveComponent("amountInput")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Dialog = _resolveComponent("Dialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_ctx.selectedOrder)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode("div", _hoisted_10, [
                    _createVNode("b", null, _toDisplayString(_ctx.selectedOrder?.pair?.baseCurrency?.id) + " - " + _toDisplayString(_ctx.selectedOrder?.pair?.quoteCurrency?.id), 1)
                  ])
                ]),
                _hoisted_11,
                _createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, [
                    (_ctx.selectedOrder?.side == 1)
                      ? (_openBlock(), _createBlock("span", _hoisted_15, " BUY "))
                      : (_openBlock(), _createBlock("span", _hoisted_16, "SELL"))
                  ])
                ]),
                _hoisted_17,
                _createVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode("div", _hoisted_20, [
                    _createVNode("b", null, _toDisplayString(_ctx.currentBaseCurrency?.id || '' + ' '), 1),
                    _hoisted_21,
                    _createVNode("code", _hoisted_22, _toDisplayString(_ctx.currentBaseCurrency?.currencyType === 1
                      ? '$ ' + _ctx.formatPrice(_ctx.selectedOrder?.amount)
                      : _ctx.formatZeros(
                          _ctx.selectedOrder?.amount,
                          _ctx.currentBaseCurrency?.exact
                        )), 1)
                  ])
                ]),
                _hoisted_23,
                _createVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode("div", _hoisted_26, [
                    _createVNode("b", null, _toDisplayString(_ctx.currentQuoteCurrency?.id || '' + ' '), 1),
                    _hoisted_27,
                    _createVNode("code", _hoisted_28, _toDisplayString(_ctx.currentQuoteCurrency?.currencyType === 1
                      ? '$ ' + _ctx.formatPrice(_ctx.selectedOrder?.unitPrice)
                      : _ctx.formatZeros(
                          _ctx.selectedOrder?.unitPrice,
                          _ctx.currentQuoteCurrency?.exact
                        )), 1)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode("div", _hoisted_32, [
                    _createVNode("table", _hoisted_33, [
                      _createVNode("tr", null, [
                        _createVNode("td", _hoisted_34, [
                          _hoisted_35,
                          (_ctx.selectedOrder?.side == 1)
                            ? (_openBlock(), _createBlock("span", _hoisted_36, "TARGET"))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("td", _hoisted_37, [
                          _createVNode("b", null, _toDisplayString(_ctx.currentBaseCurrency?.id || '' + ' '), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.currentBaseCurrency?.currencyType === 1
                          ? '$ ' + _ctx.formatPrice(_ctx.selectedOrder.amount)
                          : _ctx.formatZeros(
                              _ctx.selectedOrder.amount,
                              _ctx.currentBaseCurrency?.exact
                            )), 1)
                        ])
                      ]),
                      _createVNode("tr", null, [
                        _createVNode("td", _hoisted_38, [
                          _hoisted_39,
                          (_ctx.selectedOrder?.side == 2)
                            ? (_openBlock(), _createBlock("span", _hoisted_40, "TARGET"))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("td", _hoisted_41, [
                          _createVNode("b", null, _toDisplayString(_ctx.currentQuoteCurrency?.id || '' + ' '), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.currentQuoteCurrency?.currencyType === 1
                          ? '$ ' + _ctx.formatPrice(_ctx.selectedOrder?.finalPrice)
                          : _ctx.formatZeros(
                              _ctx.selectedOrder?.finalPrice,
                              _ctx.currentQuoteCurrency?.exact
                            )), 1)
                        ])
                      ]),
                      _createVNode("tr", null, [
                        _hoisted_42,
                        _createVNode("td", _hoisted_43, [
                          _createVNode(_component_InputNumber, {
                            disabled: true,
                            class: "form-control text-right p-0",
                            inputClass: "w-100 text-right",
                            modelValue: _ctx.selectedOrder.totalCostCad,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedOrder.totalCostCad = $event)),
                            mode: "decimal",
                            minFractionDigits: 2,
                            prefix: "CAD $"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createVNode("tr", null, [
                        _hoisted_44,
                        _createVNode("td", _hoisted_45, [
                          _createVNode("b", null, _toDisplayString(_ctx.currentBaseCurrency?.id || '' + ' '), 1),
                          _createTextVNode("   " + _toDisplayString(_ctx.currentBaseCurrency?.currencyType === 1
                          ? '$ ' + _ctx.formatPrice(_ctx.totalAmount)
                          : _ctx.formatZeros(
                              _ctx.totalAmount,
                              _ctx.currentBaseCurrency?.exact
                            ) || 0), 1)
                        ])
                      ]),
                      _createVNode("tr", null, [
                        _hoisted_46,
                        _createVNode("td", _hoisted_47, [
                          _createVNode("b", null, _toDisplayString(_ctx.currentQuoteCurrency?.id || '' + ' '), 1),
                          _createTextVNode("   " + _toDisplayString(_ctx.currentQuoteCurrency?.currencyType === 1
                          ? '$ ' + _ctx.formatPrice(_ctx.totalCost)
                          : _ctx.formatZeros(
                              _ctx.totalCost,
                              _ctx.currentQuoteCurrency?.exact
                            ) || 0), 1)
                        ])
                      ]),
                      _createVNode("tr", null, [
                        _createVNode("td", _hoisted_48, [
                          _hoisted_49,
                          (_ctx.progress == 0)
                            ? (_openBlock(), _createBlock("span", _hoisted_50, "PENDING"))
                            : _createCommentVNode("", true),
                          (_ctx.progress > 0 && _ctx.progress < 100)
                            ? (_openBlock(), _createBlock("span", _hoisted_51, "PARTIALLY FILLED"))
                            : _createCommentVNode("", true),
                          (_ctx.progress >= 100)
                            ? (_openBlock(), _createBlock("span", _hoisted_52, "FILLED"))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode("td", _hoisted_53, _toDisplayString(_ctx.progress) + "%", 1)
                      ]),
                      _createVNode("tr", null, [
                        _createVNode("td", _hoisted_54, [
                          _createVNode(_component_ProgressBar, {
                            value: _ctx.progress,
                            showValue: false
                          }, null, 8, ["value"])
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_55,
                  _createVNode("div", _hoisted_56, [
                    _createVNode("table", _hoisted_57, [
                      _hoisted_58,
                      _createVNode("tr", null, [
                        _createVNode("td", null, [
                          _createVNode(_component_icons_currency, {
                            cryptoCurrency: _ctx.currentPair?.baseCurrencyId,
                            width: '20',
                            height: '20',
                            key: _ctx.currentPair?.baseCurrencyId
                          }, null, 8, ["cryptoCurrency"]),
                          _hoisted_59,
                          (_ctx.currentBaseCurrency?.currencyType === 1)
                            ? (_openBlock(), _createBlock("span", _hoisted_60, " $" + _toDisplayString(_ctx.formatPrice(_ctx.baseCurrencyRevenue)), 1))
                            : (_ctx.currentBaseCurrency?.currencyType === 0)
                              ? (_openBlock(), _createBlock("span", _hoisted_61, _toDisplayString(_ctx.formatPrice(_ctx.baseCurrencyRevenue, 12)), 1))
                              : (_openBlock(), _createBlock("span", _hoisted_62, " 0 "))
                        ]),
                        _createVNode("td", _hoisted_63, [
                          (_ctx.currentQuoteCurrency?.currencyType === 1)
                            ? (_openBlock(), _createBlock("span", _hoisted_64, " $" + _toDisplayString(_ctx.formatPrice(_ctx.quoteCurrencyRevenue)), 1))
                            : (_ctx.currentQuoteCurrency?.currencyType === 0)
                              ? (_openBlock(), _createBlock("span", _hoisted_65, _toDisplayString(_ctx.formatPrice(_ctx.quoteCurrencyRevenue, 12)), 1))
                              : (_openBlock(), _createBlock("span", _hoisted_66, " 0 ")),
                          _hoisted_67,
                          _createVNode(_component_icons_currency, {
                            cryptoCurrency: 
                          !_ctx.isFiat(_ctx.currentPair?.quoteCurrencyId)
                            ? _ctx.currentPair?.quoteCurrencyId
                            : null
                        ,
                            localCurrency: 
                          _ctx.isFiat(_ctx.currentPair?.quoteCurrencyId)
                            ? _ctx.currentPair?.quoteCurrencyId
                            : null
                        ,
                            width: '20',
                            height: '20',
                            key: _ctx.currentPair?.quoteCurrencyId
                          }, null, 8, ["cryptoCurrency", "localCurrency"])
                        ])
                      ]),
                      (
                      _ctx.providerOrders.length &&
                        _ctx.revenueBalance !== null &&
                        _ctx.revenueBalance[0] >= 0 &&
                        _ctx.revenueBalance[1] >= 0 &&
                        (_ctx.revenueBalance[0] > 0 || _ctx.revenueBalance[1] > 0)
                    )
                        ? (_openBlock(), _createBlock("tr", _hoisted_68, [
                            _createVNode("td", _hoisted_69, _toDisplayString(_ctx.providerOrders.length && _ctx.revenueBalance !== null
                          ? _ctx.revenueBalance[0]
                          : 0) + "% ", 1),
                            _createVNode("td", _hoisted_70, _toDisplayString(_ctx.providerOrders.length && _ctx.revenueBalance !== null
                          ? _ctx.revenueBalance[1]
                          : 0) + "% ", 1)
                          ]))
                        : _createCommentVNode("", true),
                      (
                      _ctx.providerOrders.length &&
                        _ctx.revenueBalance !== null &&
                        _ctx.revenueBalance[0] >= 0 &&
                        _ctx.revenueBalance[1] >= 0 &&
                        (_ctx.revenueBalance[0] > 0 || _ctx.revenueBalance[1] > 0)
                    )
                        ? (_openBlock(), _createBlock("tr", _hoisted_71, [
                            _createVNode("td", {
                              colspan: "2",
                              class: ["percentage-distribution", {
                        inactive:
                          !_ctx.providerOrders.length || _ctx.revenueBalance == null
                      }]
                            }, [
                              _createVNode(_component_ProgressBar, {
                                value: _ctx.revenueBalanceForBar,
                                showValue: false
                              }, null, 8, ["value"])
                            ], 2)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_72, [
              _createVNode("div", _hoisted_73, [
                _hoisted_74,
                _createVNode("div", _hoisted_75, [
                  _createVNode("div", _hoisted_76, [
                    _createVNode("div", _hoisted_77, [
                      _hoisted_78,
                      _withDirectives(_createVNode("select", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.fillingOrder.providerId = $event)),
                        disabled: !_ctx.providers || _ctx.providers.length == 0,
                        class: "form-control text-right",
                        id: "provider-field"
                      }, [
                        _hoisted_79,
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.providers, (provider) => {
                          return (_openBlock(), _createBlock("option", {
                            key: provider.id,
                            value: provider.id
                          }, _toDisplayString(provider.name), 9, ["value"]))
                        }), 128))
                      ], 8, ["disabled"]), [
                        [_vModelSelect, _ctx.fillingOrder.providerId]
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_80, [
                    _createVNode("div", _hoisted_81, [
                      _hoisted_82,
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.fillingOrder.externalProviderOrderId = $event)),
                        type: "text",
                        class: "form-control",
                        id: "provider-order-id"
                      }, null, 512), [
                        [_vModelText, _ctx.fillingOrder.externalProviderOrderId]
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_83, [
                    _hoisted_84,
                    _createVNode("div", _hoisted_85, [
                      _createVNode("div", _hoisted_86, [
                        _createVNode("span", _hoisted_87, [
                          _createVNode("button", {
                            class: "btn btn-primary",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toMaximum && _ctx.toMaximum(...args)))
                          }, [
                            _hoisted_88
                          ])
                        ]),
                        _createVNode("span", _hoisted_89, _toDisplayString(_ctx.currentBaseCurrency?.id), 1)
                      ]),
                      _createVNode(_component_amountInput, {
                        "onUpdate:amount": _cache[5] || (_cache[5] = ($event: any) => (_ctx.fillingOrder.amount = parseFloat($event))),
                        amount: _ctx.fillingOrder.amount,
                        onInput: _ctx.changeAmount,
                        precision: 12
                      }, null, 8, ["amount", "onInput"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_90, [
                    _createVNode("div", _hoisted_91, [
                      _hoisted_92,
                      _createVNode("div", _hoisted_93, [
                        _createVNode("div", _hoisted_94, [
                          _createVNode("div", _hoisted_95, _toDisplayString(_ctx.currentQuoteCurrency?.id), 1)
                        ]),
                        _createVNode(_component_amountInput, {
                          disabled: true,
                          value: _ctx.getUnitPrice,
                          precision: 12
                        }, null, 8, ["value"])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_96, [
                    _createVNode("div", _hoisted_97, [
                      _hoisted_98,
                      _createVNode("div", _hoisted_99, [
                        _createVNode("div", _hoisted_100, [
                          _createVNode("div", _hoisted_101, _toDisplayString(_ctx.currentQuoteCurrency?.id), 1)
                        ]),
                        _createVNode(_component_amountInput, {
                          disabled: !_ctx.fillingOrder.amount,
                          style: {"padding-right":"31px"},
                          "onUpdate:amount": _cache[6] || (_cache[6] = ($event: any) => (
                        _ctx.fillingOrder.totalCost = parseFloat($event)
                      )),
                          amount: _ctx.fillingOrder.totalCost,
                          onInput: _ctx.changeTotalCost,
                          precision: 12
                        }, null, 8, ["disabled", "amount", "onInput"])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_102, [
                  _createVNode("div", _hoisted_103, [
                    _hoisted_104,
                    _hoisted_105,
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.fillingOrder.settlementDatetime = $event)),
                      type: "datetime-local",
                      step: "1",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.fillingOrder.settlementDatetime]
                    ]),
                    _hoisted_106,
                    (_ctx.hasFillingOrderDateError)
                      ? (_openBlock(), _createBlock("small", _hoisted_107, " Invalid Date "))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_108, [
                    _hoisted_109,
                    _hoisted_110,
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      style: {"height":"fit-content","width":"100%"},
                      disabled: !_ctx.canAddProviderOrder,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addProviderOrder()))
                    }, [
                      _hoisted_111
                    ], 8, ["disabled"])
                  ])
                ]),
                _createVNode(_component_DataTable, {
                  value: _ctx.providerOrders,
                  rowClass: data => (data.id ? 'blocked' : ''),
                  paginator: false,
                  autoLayout: true
                }, {
                  empty: _withCtx(() => [
                    _hoisted_112
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "providerName",
                      header: "Provider",
                      bodyStyle: "text-align: left",
                      footer: "TOTAL"
                    }, {
                      body: _withCtx(({data}) => [
                        _withDirectives(_createVNode("div", null, [
                          _createTextVNode(_toDisplayString(data?.id
                        ? data.provider.name
                        : _ctx.getProviderNameById(data.providerId)) + " ", 1),
                          _hoisted_113
                        ], 512), [
                          [_directive_tooltip, 
                      'Provider Order ID: ' +
                        (data.externalProviderOrderId
                          ? data.externalProviderOrderId
                          : 'No specified')
                    ]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      header: "Amount",
                      headerClass: "text-center",
                      bodyClass: "text-right",
                      footerClass: "text-right"
                    }, {
                      body: _withCtx(({data}) => [
                        _createTextVNode(_toDisplayString(_ctx.currentBaseCurrency?.id +
                      (_ctx.currentBaseCurrency?.currencyType === 1 ? '$' : '') +
                      ' ') + " " + _toDisplayString(_ctx.formatZeros(data.amount, 12)), 1)
                      ]),
                      footer: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.currentBaseCurrency?.id +
                      (_ctx.currentBaseCurrency?.currencyType === 1 ? '$' : '') +
                      ' ') + " " + _toDisplayString(_ctx.formatZeros(_ctx.totalAmount, 12)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      header: "Side",
                      headerClass: "text-center",
                      bodyStyle: "text-align: left"
                    }, {
                      body: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.selectedOrder?.side == 1 ? 'BUY' : 'SELL'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      header: "Unit Price",
                      headerClass: "text-center",
                      bodyClass: "text-right"
                    }, {
                      body: _withCtx(({data}) => [
                        _createTextVNode(_toDisplayString(_ctx.currentQuoteCurrency?.id +
                      (_ctx.currentQuoteCurrency?.currencyType === 1 ? '$' : '') +
                      ' ') + " " + _toDisplayString(_ctx.formatZeros(data.unitCost, 12)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      header: "Total Price",
                      headerClass: "text-center",
                      bodyClass: "text-right",
                      footerClass: "text-right"
                    }, {
                      body: _withCtx(({data}) => [
                        _createTextVNode(_toDisplayString(_ctx.currentQuoteCurrency?.id +
                      (_ctx.currentQuoteCurrency?.currencyType === 1 ? '$' : '') +
                      ' ') + " " + _toDisplayString(_ctx.formatZeros(data.totalCost, 12)), 1)
                      ]),
                      footer: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.currentQuoteCurrency?.id +
                      (_ctx.currentQuoteCurrency?.currencyType === 1 ? '$' : '') +
                      ' ') + " " + _toDisplayString(_ctx.formatZeros(_ctx.totalCost, 12)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      header: "Settlement Date",
                      headerClass: "text-right",
                      bodyClass: "text-right"
                    }, {
                      body: _withCtx(({data}) => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(data.settlementDatetime)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      header: "",
                      headerClass: "text-right",
                      bodyClass: "text-right"
                    }, {
                      body: _withCtx(({data,index}) => [
                        (!data.id)
                          ? (_openBlock(), _createBlock("button", {
                              key: 0,
                              class: "remove-row",
                              type: "button",
                              style: {"background":"transparent","border":"none"},
                              onClick: ($event: any) => (_ctx.removeRow(index))
                            }, [
                              _hoisted_114
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "rowClass"])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_115, [
          _createVNode("div", _hoisted_116, [
            _createVNode("div", _hoisted_117, [
              _createVNode("div", _hoisted_118, [
                _createVNode(_component_Dialog, {
                  header: "Confirmation",
                  visible: _ctx.showModalcloseOrder,
                  "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (_ctx.showModalcloseOrder = $event))
                }, {
                  footer: _withCtx(() => [
                    _createVNode("button", {
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showModalcloseOrder = false)),
                      class: "btn btn-danger"
                    }, " No "),
                    _createVNode("button", {
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeOrder && _ctx.closeOrder(...args))),
                      class: "btn btn-success"
                    }, " Yes ")
                  ]),
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_119, [
                      _hoisted_120,
                      _createVNode("div", _hoisted_121, [
                        _createVNode("div", _hoisted_122, [
                          _createVNode("small", null, [
                            _createTextVNode(" Base Currency Revenue: " + _toDisplayString(_ctx.currentPair.baseCurrencyId) + " ", 1),
                            _createVNode("b", null, _toDisplayString(_ctx.currentBaseCurrency?.currencyType === 1
                            ? ' $' + _ctx.formatPrice(_ctx.baseCurrencyRevenue)
                            : _ctx.formatZeros(
                                _ctx.baseCurrencyRevenue,
                                _ctx.currentBaseCurrency?.exact
                              )), 1)
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_123, [
                        _createVNode("div", _hoisted_124, [
                          _createVNode("small", null, [
                            _createTextVNode(" Quote Currency Revenue: " + _toDisplayString(_ctx.currentPair.quoteCurrencyId) + " ", 1),
                            _createVNode("b", null, _toDisplayString(_ctx.currentQuoteCurrency?.currencyType === 1
                            ? ' $' + _ctx.formatPrice(_ctx.quoteCurrencyRevenue)
                            : _ctx.formatZeros(
                                _ctx.quoteCurrencyRevenue,
                                _ctx.currentQuoteCurrency?.exact
                              )), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["visible"]),
                _createVNode("button", {
                  disabled: 
                _ctx.currentCreateOrderStatus == 'fetching' ||
                  _ctx.selectedOrder?.providerOrders?.length === 0
              ,
                  type: "button",
                  class: "btn btn-danger ml-3",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.openModalcloseOrder()))
                }, " Close order ", 8, ["disabled"]),
                _createVNode("button", {
                  disabled: 
                _ctx.currentCreateOrderStatus == 'fetching' ||
                  _ctx.providerOrders?.length === 0
              ,
                  type: "button",
                  class: "btn btn-primary ml-3",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.executeSaveOrder()))
                }, " Save order ", 8, ["disabled"])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}